/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Swift_Otter_GlideInputs */

const en_warm_swift_otter_glide = /** @type {(inputs: Warm_Swift_Otter_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic`)
};

const de_warm_swift_otter_glide = /** @type {(inputs: Warm_Swift_Otter_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfach`)
};

/**
* | output |
* | --- |
* | "Basic" |
*
* @param {Warm_Swift_Otter_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_swift_otter_glide = /** @type {((inputs?: Warm_Swift_Otter_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Swift_Otter_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_swift_otter_glide(inputs)
	return de_warm_swift_otter_glide(inputs)
});